import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import { updatePublicationCriteriaFilterOption, usePublicationCriteriaFilter } from '@medifind/zustand';
import FilterChips from './FilterChips';
import StoreFilterAutocomplete from './StoreFilterAutocomplete';
import styles from './FilterShared.module.scss';

const PublicationResultFilterList = ({ criteriaKeywords }) => {
  const [criteriaValues, publicationCriteria] = usePublicationCriteriaFilter((state) => [state.selected, state]);
  const allSuggestions = criteriaKeywords ? criteriaKeywords.map((d) => ({ display: d, value: d })) : [];
  const criteriaAutocomplete = async (value) => {
    if (value.trim()) {
      return [
        { display: value, value: value.toLowerCase() },
        ...allSuggestions.filter((d) => d.value.toLowerCase().startsWith(value.toLowerCase())),
      ];
    } else {
      return allSuggestions;
    }
  };
  return (
    <Container className={styles['result-filter-list__container']}>
      <Row>
        <StoreFilterAutocomplete
          filter={publicationCriteria}
          label={`Term Search`}
          placeholder="Ex. stem cell"
          autocompleteFunction={criteriaAutocomplete}
          prepopulateOnFocus
          fullWidth
          actLikeASelect
          clearInputAfterSelect
          showClearButton
          noResultsString="Press enter to add criteria"
        />
        <FilterChips
          values={criteriaValues}
          explanation={'You can select from the dropdown list OR enter your own terms to refine the search.'}
          onChipUpdate={(arr) => updatePublicationCriteriaFilterOption(arr)}
        />
      </Row>
    </Container>
  );
};

PublicationResultFilterList.propTypes = {
  criteriaKeywords: PropTypes.array,
};

export { PublicationResultFilterList as default, PublicationResultFilterList };
